module.exports = __webpack_public_path__ + "staticfr/media/flautanovo.aee910a1.mp4";